export interface SeguroDesempregoInputData {
  readonly antepenultimoSalario: string;
  readonly penultimoSalario: string;
  readonly ultimoSalario: string;
  readonly historicoRecebimento: 'nunca' | 'uma_vez' | 'duas_ou_mais';
  readonly mesesTrabalhados: string;
}

export interface SalariosDetalhamento {
  readonly antepenultimo: number;
  readonly penultimo: number;
  readonly ultimo: number;
  readonly media: number;
}

export interface FaixaAplicada {
  readonly numero: 1 | 2 | 3;
  readonly descricao: string;
  readonly calculo: string;
  readonly valorBruto: number;
  readonly valorFinal: number;
  readonly limiteFaixa?: string;
}

export interface NumeroParcelas {
  readonly baseHistorico: string;
  readonly mesesTrabalhados: number;
  readonly mesesNecessarios: number;
  readonly parcelasCalculadas: number;
  readonly parcelasFinal: number;
}

export interface CalculoBreakdown {
  readonly salarios: SalariosDetalhamento;
  readonly faixaAplicada: FaixaAplicada;
  readonly numeroParcelas: NumeroParcelas;
}

export interface CronogramaParcela {
  readonly numero: number;
  readonly valor: number;
  readonly dataEstimada: string;
}

export interface SeguroDesempregoResultsType {
  readonly elegivel: boolean;
  readonly motivoInelegibilidade?: string;
  readonly salarioMedio: number;
  readonly valorParcela: number;
  readonly numeroParcelas: number;
  readonly valorTotal: number;
  readonly faixaAplicada: 1 | 2 | 3;
  readonly detalhamentoCalculo: CalculoBreakdown;
  readonly cronogramaParcelas: Array<CronogramaParcela>;
}

// Mensagens de validação
export const ValidationMessages = {
  SALARIOS_OBRIGATORIOS: "Informe os três últimos salários.",
  SALARIO_INVALIDO: "Salário deve ser maior que zero.",
  MESES_OBRIGATORIO: "Informe os meses trabalhados.",
  MESES_INSUFICIENTES: "Tempo trabalhado insuficiente para o benefício.",
  HISTORICO_OBRIGATORIO: "Selecione o histórico de recebimento.",
  MESES_INVALIDO: "Número de meses deve ser maior que zero.",
  ERRO_CALCULO: "Erro no cálculo. Verifique os dados informados.",
} as const;

export const CONSTANTES_SEGURO_DESEMPREGO_2025 = {
  SALARIO_MINIMO: 1518.00,
  PISO_BENEFICIO: 1518.00,
  TETO_BENEFICIO: 2424.11,
  FAIXA_1_LIMITE: 2138.76,
  FAIXA_1_ALIQUOTA: 0.8,
  FAIXA_2_LIMITE: 3564.96,
  FAIXA_2_BASE: 1711.01,
  FAIXA_2_ALIQUOTA: 0.5,
  INPC_2024: 4.77,
} as const;

export const REQUISITOS_TEMPO_TRABALHO = {
  nunca: {
    periodo: 18,
    mesesMinimos: 12,
    descricao: 'Primeira solicitação',
    detalhamento: 'Você precisa de pelo menos 12 meses trabalhados nos últimos 18 meses',
    orientacao: '12-23 meses = 4 parcelas | 24+ meses = 5 parcelas',
    parcelas: {
      12: 4,  // 12-23 meses = 4 parcelas
      24: 5   // 24+ meses = 5 parcelas
    }
  },
  uma_vez: {
    periodo: 12,
    mesesMinimos: 9,
    descricao: 'Segunda solicitação',
    detalhamento: 'Você precisa de pelo menos 9 meses trabalhados nos últimos 12 meses',
    orientacao: '9-11 meses = 3 parcelas | 12-23 meses = 4 parcelas | 24+ meses = 5 parcelas',
    parcelas: {
      9: 3,   // 9-11 meses = 3 parcelas
      12: 4,  // 12-23 meses = 4 parcelas
      24: 5   // 24+ meses = 5 parcelas
    }
  },
  duas_ou_mais: {
    periodo: 6,
    mesesMinimos: 6,
    descricao: 'Terceira solicitação ou mais',
    detalhamento: 'Você precisa de pelo menos 6 meses trabalhados consecutivos',
    orientacao: '6-11 meses = 3 parcelas | 12-23 meses = 4 parcelas | 24+ meses = 5 parcelas',
    parcelas: {
      6: 3,   // 6-11 meses = 3 parcelas
      12: 4,  // 12-23 meses = 4 parcelas
      24: 5   // 24+ meses = 5 parcelas
    }
  }
} as const;

export const EXPLICACOES_CAMPOS = {
  antepenultimoSalario: "Valor bruto do 3º salário antes da demissão.",
  
  penultimoSalario: "Valor bruto do 2º salário antes da demissão.",
  
  ultimoSalario: "Valor bruto do último salário recebido antes da demissão.",
  
  historicoRecebimento: "Quantas vezes você já recebeu seguro-desemprego anteriormente",
  
  mesesTrabalhados: "Informe o total de meses que você trabalhou consecutivamente antes da demissão.",
  
  calculoFaixas: "O valor é calculado por faixas salariais progressivas.",
  
  numeroParcelas: "Número de parcelas varia de 3 a 5 meses.",
  
  prazoSolicitacao: "O seguro-desemprego deve ser solicitado entre o 7º e 120º dia após a demissão."
} as const;